import { IPalette, ISemanticColors } from '../colors';
import { CommunicationColors, DefaultColors, NeutralColors, SharedColors, YammerColors } from '../colors/yammerPalette';

import { createCustomizedThemeWithSlotOverrides } from './createCustomizedThemeWithSlotOverrides';
import { defaultDarkTheme } from './default';
import { ITheme } from './theme.types';

const updatedDarkThemeColors: Partial<IPalette> = {
  white: NeutralColors.black,
  black: NeutralColors.white,
  neutralDark: NeutralColors.gray20,
  neutralPrimary: NeutralColors.gray30,
  neutralPrimaryAlt: NeutralColors.gray40,
  neutralLight: NeutralColors.gray160,
  neutralLighter: NeutralColors.gray170,
  neutralLighterAlt: NeutralColors.gray220,
  neutralSecondary: NeutralColors.gray50,
  neutralSecondaryAlt: NeutralColors.gray90,
  neutralTertiary: NeutralColors.gray100,
  neutralTertiaryAlt: NeutralColors.gray110,
  neutralQuaternary: NeutralColors.gray130,
  neutralQuaternaryAlt: NeutralColors.gray150,
  themeDark: NeutralColors.gray40,
  themeDarkAlt: NeutralColors.gray50,
  themeDarker: NeutralColors.gray20,
  themePrimary: NeutralColors.white,
  themeSecondary: NeutralColors.gray60,
  themeTertiary: NeutralColors.gray90,
  themeLight: NeutralColors.gray140,
  themeLighter: NeutralColors.gray190,
  themeLighterAlt: NeutralColors.gray220,
  accent: YammerColors.yammerTint30,
  blueDark: SharedColors.cyanBlue20,
  blueLight: YammerColors.yammerTint30,
  blueMid: YammerColors.yammerTint20,
  magenta: SharedColors.magenta10,
  magentaDark: SharedColors.magentaPink10,
  magentaLight: SharedColors.magenta20,
  orange: SharedColors.orange20,
  orangeLight: YammerColors.heartRed,
  orangeLighter: SharedColors.orange10,
  purple: DefaultColors.purple,
  purpleLight: SharedColors.blueMagenta10,
  purpleDark: SharedColors.blueMagenta20,
  red: SharedColors.red20,
  redDark: SharedColors.red10,
  teal: SharedColors.cyan20,
  tealDark: SharedColors.cyan30,
  tealLight: DefaultColors.tealLight,
  yellow: DefaultColors.yellow,
  yellowDark: SharedColors.yellow10,
  yellowLight: DefaultColors.yellowDark,
};

const updatedDarkThemeSematicColors: Partial<ISemanticColors> = {
  bodyBackground: NeutralColors.gray220,
  bodyBackgroundHovered: NeutralColors.gray150,
  bodyFrameBackground: NeutralColors.gray10,
  bodyStandoutBackground: NeutralColors.gray190,
  bodyText: NeutralColors.gray20,
  bodySubtext: NeutralColors.gray50,
  buttonBackground: NeutralColors.gray170,
  buttonBackgroundHovered: NeutralColors.gray190,
  buttonBackgroundPressed: NeutralColors.gray210,
  buttonBorder: NeutralColors.gray130,
  buttonText: NeutralColors.white,
  buttonTextDisabled: NeutralColors.gray50,
  disabledText: NeutralColors.gray50,
  inputBorder: NeutralColors.gray130,
  inputBackgroundChecked: NeutralColors.white,
  inputBorderHovered: NeutralColors.gray50,
  inputText: NeutralColors.gray20,
  link: NeutralColors.gray50,
  linkHovered: CommunicationColors.tint10,
  menuIcon: NeutralColors.white,
  menuHeader: NeutralColors.white,
  primaryButtonBackground: NeutralColors.white,
  primaryButtonBackgroundHovered: NeutralColors.gray50,
  primaryButtonBackgroundPressed: NeutralColors.gray40,
  primaryButtonTextDisabled: NeutralColors.gray50,
};

export const updatedDarkTheme: ITheme = createCustomizedThemeWithSlotOverrides({
  name: 'updatedDarkTheme',
  theme: defaultDarkTheme,
  paletteOverrides: updatedDarkThemeColors,
  semanticColorOverrides: updatedDarkThemeSematicColors,
});
